const GET_SUBCATEGORIES = "GET_SUBCATEGORIES";
const GET_SUBCATEGORIES_SUCCESS = "GET_SUBCATEGORIES_SUCCESS";
const GET_SUBCATEGORIES_FAILURE = "GET_SUBCATEGORIES_FAILURE";
const CLEAR_GET_SUBCATEGORIES = "CLEAR_GET_SUBCATEGORIES";

const subcategorySymbols = {
  GET_SUBCATEGORIES_SUCCESS,
  GET_SUBCATEGORIES_FAILURE,
  GET_SUBCATEGORIES,
  CLEAR_GET_SUBCATEGORIES,
};
export default subcategorySymbols;
